export const popInMotionConfig = () => ({
	animate: {
		scale: 1,
		transition: { duration: 0.7, type: 'spring' },
	},
	initial: { scale: 0 },
	exit: { scale: 0 },
});

export const fadeInConfig = () => ({
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	transition: {
		duration: 1,
		ease: 'easeOut',
	},
});

export const fastFadeInConfig = () => ({
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	transition: {
		duration: 0.2,
		ease: 'easeOut',
	},
});

// export const mobileCustomizerContainerMotionConfig = () => ({
// 	initial: { x: '-20px', opacity: 0 },
// 	animate: { x: '0px', opacity: 1 },
// 	transition: { duration: 2, type: 'spring' },
// 	exit: {
// 		x: '100%',
// 		opacity: 0,
// 		transition: { duration: 0.5, ease: 'easeOut' },
// 	},
// });

// export const mobileCustomizerChildrenMotionConfig = (
// 	initial: string,
// 	duration: number
// ) => ({
// 	initial: { x: initial },
// 	animate: { x: '0px' },
// 	transition: { duration: duration, type: 'spring' },
// });

// export const mobileCustomizerLevelMotionConfig = () => ({
// 	initial: { opacity: 0, scale: 0.5 },
// 	animate: { opacity: 1, scale: 1 },
// 	transition: { duration: 0.4 },
// });

export const associationMotionConfig = () => ({
	animate: { scale: [1, 0.94, 1] },
	transition: { duration: 1.4, repeat: Infinity, repeatDelay: 2 },
});
